import { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  Typography,
  Divider,
  AccordionDetails,
  AccordionActions,
  Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import {
  ExpandMore as ExpandMoreIcon,
  FilterList as FilterListIcon,
  Clear as ClearIcon,
  FilterAltOutlined,
} from '@mui/icons-material';
import FlatIcon, { FlatIconOptions } from '../FlatIcon';

const useStyles = makeStyles({
  filterPanel: {
    marginTop: 0,
  },
  divHeader: {
    marginTop: '5px',
  },
  divcontaineir: {
    marginBottom: 10,
    width: '100%',
  },
});

function FilterBar({ title, children, searchFilter, clearFilter, awaysOpen = false }) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(awaysOpen);

  const handleAccordionChange = (event, isExpanded) => {
    if (!awaysOpen) {
      setExpanded(isExpanded);
    }
  };

  return (
    <div
      className={classes.divcontaineir}
      style={{ display: 'grid', gridTemplateColumns: `auto 100` }}>
      <Accordion
        className={classes.filterPanel}
        expanded={expanded}
        onChange={handleAccordionChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1c-content'
          id='panel1c-header'>
          <Typography
            variant='caption'
            component='p'>
            {title}
          </Typography>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>{children}</AccordionDetails>
        <Divider />
        <AccordionActions>
          <Button
            size='small'
            onClick={searchFilter}>
            <FlatIcon icon={FlatIconOptions.filter} />
          </Button>
          <Button
            size='small'
            color='primary'
            onClick={clearFilter}>
            <FlatIcon icon={FlatIconOptions.clearFilter} /> Limpar
          </Button>
        </AccordionActions>
      </Accordion>
    </div>
  );
}

export default FilterBar;
